module.exports = __webpack_public_path__ + "img/inter_sprint_logo.e8b4f0ea.png";